import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: "hash",
  routes: routes
})

// 路由跳转前
router.beforeEach((to, from, next) => {
  next();
})

// 路由跳转后
router.afterEach((route, from) => {
   window.scrollTo(0,0);
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js